/* Copyright (c) 2023 VMware, Inc. All rights reserved. -- VMware Confidential */

import { Event } from "@app/services/dispatcher/events/event";
import { MaintenanceScheduleTenantGetResponseSpec } from "@api/generated/vcdr";

export class MaintenanceModeEvent extends Event {
    public static ID: string = "MAINTENANCE_MODE_EVENT";

    constructor(public schedule: MaintenanceScheduleTenantGetResponseSpec) {
        super(MaintenanceModeEvent.ID);
    }
}
